import React, { Component } from 'react';
import DropDown2 from './DropDown2'

const unitApiValues = ["Gallons", "KWatt_Hours", "Liters", "Hours", "Minutes", "ccf", "Cf",
  "kBTU", "m3", "Seconds", "kWh"];
const unitDisplay = ["Gallons", "KWatt_Hours", "Liters", "Hours", "Minutes", "ccf", "cf",
  "kBTU", "m3", "Seconds", "kWh"];

export default class UnitsDropdown extends Component {
  constructor(props) {
    super(props);

    this.apiValues = unitApiValues;
    this.state = {
      options: unitDisplay,
    }
  }
  render () {
    const pr = this.props
    const readOnly = pr?.readOnly || pr?.disabled
    const dd2 = UnitsDisplay (pr?.value)
    return <DropDown2 {...this.state} {...pr} value={dd2} readOnly={readOnly}
        onUpdate={(param)=>pr.onUpdate (this.apiValues[param], pr)}/>
  }
}

export function UnitsDisplay (apiValue) {
  apiValue = apiValue ?? ''
  const found = unitApiValues.indexOf(apiValue)
  return found < 0 ? (apiValue ? apiValue : "Not Available") : unitDisplay[found]
}
